import { render, staticRenderFns } from "./PublishingStatementsArchivingDialog.vue?vue&type=template&id=40a63ecf"
import script from "./PublishingStatementsArchivingDialog.vue?vue&type=script&lang=js"
export * from "./PublishingStatementsArchivingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports